module.exports = __webpack_public_path__ + "media/components/shared/ExclusiveLabel/First-to-market-label-d19e4f3ea6f19b60bea9b7fe4b8f313a.png";